import { useRouteError } from 'react-router-dom'
import NavBar from '../Components/NavBar'

const ErrorPage = () => {
  const error = useRouteError()

  return (
    <>
      <NavBar />
      <div className="flex flex-col items-center justify-center py-24 px-4 max-w-7xl mx-auto">
        <h1 className="font-heading text-6xl text-primary-light mb-4">Oops!</h1>
        <p className="font-body text-lg text-neutral-300 mb-2">This is not the page you're looking for</p>
        <p className="font-body text-sm text-neutral-500">
          <i>{ error.statusText || error.message }</i>
        </p>
      </div>
    </>
  )
}

export default ErrorPage;
